import { createUseStyles } from '@glu/theming';

export default createUseStyles(({
  nav: {
    direction,
    collapsed,
    expanded,
    color,
    breakpoints,
    hamburgerButtonColor,
    panelBeforeBackground,
    header,
    contentBackgroundColor,
    outline
  }
}) => ({
  root: {
    background: `
      linear-gradient(
        90deg,
        ${collapsed.gradientStart},
        ${collapsed.gradientEnd}
      )
    `,
    boxSizing: 'border-box',
    color,
    fill: color,
    height: 56,
    padding: '12px 15px',
    position: 'relative',
    width: '100%',

    [`@media (min-width: ${breakpoints.dockCollapsedToTop}px)`]: {
      background: `
        linear-gradient(
          ${collapsed.direction || direction},
          ${collapsed.gradientStart},
          ${collapsed.gradientEnd}
        )
      `,
      height: '100vh',
      padding: '14px 15px',
      width: 68
    }
  },

  panel: {
    background: `
      linear-gradient(
        ${expanded.direction || direction},
        ${expanded.gradientStart},
        ${expanded.gradientEnd} 95%
      )
    `,

    '&:before': {
      background: panelBeforeBackground || `
        linear-gradient(
          ${collapsed.direction || direction},
          ${collapsed.gradientStart},
          ${collapsed.gradientEnd} 95%
        )
      `,
      top: 89,
      width: 10
    }
  },

  drawerBlackout: ({ stayOpenAtWidth }) => ({
    background: '#000',
    height: '100vh',
    left: 0,
    opacity: 0.3,
    pointerEvents: 'none',
    position: 'fixed',
    top: 0,
    width: '100vw',
    zIndex: 1,

    ...(stayOpenAtWidth
      ? {
        [`@media (min-width: ${stayOpenAtWidth}px)`]: {
          display: 'none'
        }
      }
      : undefined
    )
  }),

  hamburgerButton: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    fontWeight: 'bold',
    left: 20,
    padding: 0,
    position: 'absolute',
    transition: 'opacity 100ms ease-in-out',
    top: '50%',
    transform: 'translateY(-50%)',

    '& svg': {
      color: hamburgerButtonColor,
      fill: hamburgerButtonColor
    },

    '&:hover, &:focus': {
      opacity: 0.7
    },

    '&:focus': {
      outline: {
        width: outline.width,
        style: outline.style,
        color: outline.color
      }
    },

    '& > div': {
      display: 'block',

      [`@media (min-width: ${breakpoints.dockCollapsedToTop}px)`]: {
        display: 'inline-block'
      }
    },

    [`@media (min-width: ${breakpoints.dockCollapsedToTop}px)`]: {
      margin: [30, 'auto'],
      position: 'static',
      top: 'auto'
    }
  },

  openLogo: {
    marginLeft: 20,
    height: '100%',
    width: '100%',
    overflow: 'hidden',

    '& svg, & img': {
      height: '100%'
    }
  },

  closeButton: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 24,
    fontWeight: 'bold',
    marginLeft: 10,
    padding: 19,
    textAlign: 'left',
    transition: 'opacity 100ms ease-in-out',

    '&:hover, &:focus': {
      opacity: 0.7
    },

    '&:focus': {
      outline: {
        width: outline.width,
        style: outline.style,
        color: outline.color
      }
    },

    [`@media (min-width: ${breakpoints.dockCollapsedToTop}px)`]: {
      position: 'static',
      transform: 'none'
    }
  },

  closeIcon: {
    display: 'block'
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden'
  },

  header: {
    alignItems: 'center',
    borderBottom: header.borderBottom,
    boxSizing: 'border-box',
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    height: header.height,
    background: header.background,
    justifyContent: 'space-between',
    padding: header.padding,
    '& svg': {
      fill: header.color
    }
  },

  content: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    height: '100%',
    overflowY: 'auto',
    backgroundColor: contentBackgroundColor
  },

  navLinks: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    height: 'auto'
  },

  smallLogo: {
    height: 32,
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',

    '& > svg': {
      height: '100%'
    },

    [`@media (min-width: ${breakpoints.dockCollapsedToTop}px)`]: {
      height: 'auto',
      marginBottom: 20,
      position: 'static',
      transform: 'none'
    }
  },

  largeLogo: {
    padding: '20px 22px',

    '& svg': {
      display: 'block',
      margin: '0 auto'
    }
  },

  logo: {
    cursor: 'pointer',
    mixBlendMode: 'normal',
    opacity: 1,
    overflow: 'visible',
    pointerEvents: 'all',

    svg: {
      height: '100%'
    }
  },

  headerSpacer: {
    height: ({ headerSpacing }) => headerSpacing,
    width: '100%'
  },

  flyOut: {
    marginTop: 14
  }
}));
